import { accordion } from './modules/accordion';
import { scrollmagic } from './modules/scrollmagic';

window.addEventListener('load', () => {
  scrollmagic();
});

accordion();
